export default __webpack_public_path__ + "images/errors/internal-server.jpg";